// BottomNavBar.js

import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Home, ShoppingCart, Messages, Profile } from 'iconsax-react';

const BottomNavBar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {location.pathname !== "/login" ? <nav className="fixed bottom-0 z-50 shadow-lg left-0 w-screen text-slate-900 p-3">
        <div className="flex justify-around bg-white rounded-lg p-3 shadow-lg shadow-[rgba(0,0,0,0.075)_0px_-5px_10px_5px]">
          <Link to="/" className={`p-3 rounded-lg ${isActive('/') ? 'bg-gray-100 text-black' : 'text-black'} flex flex-col items-center justify-center gap-[13px] text-black text-xs`}>
            <Home size="24" color="#697689" variant="Bulk"/>
            Home
          </Link>
          <Link to="/bookings" className={`p-3 rounded-lg ${isActive('/bookings') ? 'bg-gray-100 text-black' : 'text-black'} flex flex-col items-center justify-center gap-[13px] text-xs`}>
            <ShoppingCart size="24" color="#697689" variant="Bulk"/>
            Bookings
          </Link>
          <Link to="/support" className={`p-3 rounded-lg ${isActive('/support') ? 'bg-gray-100 text-black' : 'text-black'} flex flex-col items-center justify-center gap-[13px] text-xs`}>
            <Messages size="24" color="#697689" variant="Bulk"/>
            Support
          </Link>
          <Link to="/profile" className={`p-3 rounded-lg ${isActive('/profile') ? 'bg-gray-100 text-black' : 'text-black'} flex flex-col items-center justify-center gap-[13px] text-xs`}>
            <Profile size="24" color="#697689" variant="Bulk"/>
            Profile
          </Link>
        </div>
      </nav>: <></>}
    </>
  );
};

export default BottomNavBar;
